import i18n from '../../../common/i18n';

export function empty(emptyErrorKey) {
    return value => (!value ? i18n(emptyErrorKey) : null);
}

export function pattern(pattern, errorKey) {
    return (value = '') => {
        if (value === '') {
            return true;
        }
        return pattern.test(value) ? null : i18n(errorKey);
    };
}

const PATTERN_PRIHLASOVACIE_MENO = /^[a-zA-Z0-9]{4,10}$/;
const PATTERN_DIACRITIC_NONUMBERS_20 = /^[ĄÀŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáàâăäĺćçčéęëěíîďđńňóôőöřůúűüýţa-zA-Z_\s\-,.]{0,20}$/;
const PATTERN_EMAIL = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/i;
const PATTERN_ULICA_A_CISLO = /^[ĄŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőöřůúűüýţ\w\s\-,./]{0,28}$/;
const PATTERN_MESTO = /^[ĄŁĽŚŠŞŤŹŽŻąłľśšşťźžżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőöřůúűüýţ\w\s\-,./]{0,40}$/;

export const patterns = {
    PATTERN_DIACRITIC_NONUMBERS_20: PATTERN_DIACRITIC_NONUMBERS_20,
    PRIHLASOVACIE_MENO: PATTERN_PRIHLASOVACIE_MENO,
    EMAIL: PATTERN_EMAIL,
    ULICA_A_CISLO: PATTERN_ULICA_A_CISLO,
    MESTO: PATTERN_MESTO,
    PSC: /^\d{5}$/
};

export function compoundValidator(...validators) {
    return (initErrors, value) => {
        return validators.reduce((errors, validator) => validator(errors, value), initErrors);
    };
}

export function firstInvalid(...fieldValidators) {
    return value => {
        for (const validator of fieldValidators) {
            const error = validator(value);
            if (error) {
                return error;
            }
        }
    };
}
